import { LoadableAfterPaint } from '@confluence/loadable';

export const SpaceTrashPortal = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpaceTrashPortal" */ './SpaceTrashPortal.tsx'))
			.SpaceTrashPortal,
	name: 'SpaceTrashPortal',
});
